import { Box, Grid2, Stack, useTheme } from '@mui/material';
import { HeaderProvider } from '../contexts/HeaderProvider';
import { Header } from './Header';
import { Menubar } from './Menubar';
import { Footer } from './Footer';
import { Outlet } from 'react-router-dom';
import { ReactNode } from 'react';
import { UserMenu } from './UserMenu';

interface DesktopLayoutProps {
  menuItems: (onMenuItemClick?: () => void) => ReactNode;
  breadcrumb?: string;
}

export const DesktopLayout = ({ menuItems, breadcrumb }: DesktopLayoutProps) => {
  const theme = useTheme();
  return (
    <HeaderProvider>
      <Grid2 container sx={{ width: '100vw', height: '100vh' }}>
        <Grid2
          size={2}
          sx={{
            borderRight: `1px solid ${theme.palette.grey[200]}`,
            backgroundColor: 'white',
            height: `calc(100vh - ${theme.spacing(7)})`,
            overflow: 'scroll',
          }}
        >
          <Menubar breadcrumb={breadcrumb}>{menuItems()}</Menubar>
        </Grid2>
        <Grid2 size={10} sx={{ height: `calc(100vh - ${theme.spacing(7)})` }}>
          <Stack direction="column" sx={{ height: '100%' }}>
            <Grid2
              container
              columns={10}
              sx={{
                width: '100%',
                height: '100px',
                position: 'sticky',
                top: 0,
                zIndex: 1100,
                boxShadow: `0px 12px 16px -4px ${theme.palette.shadows.dark}`,
                backdropFilter: 'blur(10px)',
              }}
            >
              <Grid2 size={{ lg: 8, md: 6 }} sx={{ borderRight: `1px solid ${theme.palette.grey[200]}` }}>
                <Header />
              </Grid2>
              <Grid2 size={{ lg: 2, md: 4 }}>
                <UserMenu />
              </Grid2>
            </Grid2>
            <Box
              id="scroll-container"
              flex={1}
              sx={{
                background: theme.palette.grey[50],
                overflow: 'auto',
                pt: '124px',
                pb: theme.spacing(4),
                px: theme.spacing(4),
                mt: '-100px',
              }}
            >
              <Outlet />
            </Box>
          </Stack>
        </Grid2>
        <Grid2 size={12} sx={{ height: theme.spacing(7) }}>
          <Footer />
        </Grid2>
      </Grid2>
    </HeaderProvider>
  );
};
